
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/holiday"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('holiday_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.date.required">- សូមធ្វើការជ្រើសរើសថ្ងៃខែ</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ចូល{{$t('description')}}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                <label class="label-control">{{ $t('date') }}
                                    <span class="text-danger">*</span>
                                </label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="$v.date.$model"/>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Description.$error }">
                                <label class="blue">{{ $t('description') }}
                                    <span class="text-danger">*</span>
                                </label>
                                <div>
                                    <textarea class="form-control" id="branch_address" v-model="$v.model.Description.$model"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    import moment from 'moment'
    export default {
        data: function(){
            return {
                model: {
                    OnDate: '',
                    Description: ''
                },
                date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'holiday/save',
                title: this.$t('holiday_create')
            }
        },
        created(){
            var id = this.$route.params.id;
            if(id != undefined){
                this.findById(id);
                this.actionLink = 'holiday/update';
            }
        },
        validations: {
            model :{
                // OnDate: { required },
                Description: { required }
            },
            date: {required}
        },
        methods: {
            findById: function(id){
                let loading = this.$loading.show();
                this.$api().post('holiday/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Data;
                        this.date = moment(this.model.OnDate).format('YYYY-MM-DD');
                        this.title = this.$t('holiday_edit') +' ['+ this.date + ']';
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler: function(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    var loading = this.$loading.show();
                    this.model.OnDate = this.date;
                    this.$api().post(this.actionLink, this.model).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.push('/holiday');
                        }
                    }).finally(function () {
                        loading.hide();
                    });
                }
            }
        }
    }
</script>
